import { cn } from "@-/com.npmjs.cn";
import { Root, type RootProps, type RootRef } from "@rn-primitives/separator";
import { type RefAttributes } from "react";

export function Separator({
  className,
  decorative = true,
  orientation = "horizontal",
  ...props
}: RootProps & RefAttributes<RootRef>) {
  return (
    <Root
      className={cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className,
      )}
      decorative={decorative}
      orientation={orientation}
      {...props}
    />
  );
}
